import React, { useState } from "react";
import $ from "jquery";
import axios from "axios"; 
import FormValidator from "../../../inc/FormValidator";
import Api from "../../../inc/Api";
import Settings from "../../../inc/Settings";
import Button from "../../inc/Button";
import Collapse from "../../inc/Collapse";
import FieldsRenderer from "../../Purchase Orders Internal/Edit PO/FieldsRenderer";
import Helper from "../../../inc/Helper";
import { Form } from "react-bootstrap";
import { getPopupMessageBasedOnStatus } from "../../../inc/Validation";
import Popup from "../../Popup/Popup";
import { connect } from "react-redux";

let cancelTokenSource = axios.CancelToken.source();
const ApiMasterFormsPopup = ({ setClosePopupViewModal, reloadParentGrid }) => {
    const [popupFormData, setPopupFormData] = useState({});
 
    const [apiCallBtn, setApiCallBtn] = useState(false);

    let popupFormValidator;

    const validationConfigure = () => {
        let popupFieldConfig = [
            { name: "api_name", displayName: "Api name", types: ["Required"] },
            { name: "api_url", displayName: "Api URL", types: ["Required"] },
            { name: "api_method", displayName: "Api method", types: ["Required"] },
            { name: "api_key", displayName: "Api key", types: ["Required"] },
            { name: "api_secret", displayName: "Api secret", types: ["Required"] }, 
            { name: "api_master_id", displayName: "Api master", types: ["Required"] },
            { name: "timeout", displayName: "Timeout", types: ["Required"] },
            { name: "retry_count", displayName: "Retry count", types: ["Required"] }, 
            { name: "priority", displayName: "Priority", types: ["Required"] },
            { name: "type", displayName: "Type", types: ["Required"] },  
        ];

        if (!popupFormValidator) {
            popupFormValidator = new FormValidator(popupFieldConfig);
        }
    };

    validationConfigure();
 
    const fieldsArrayGeneral = [
        {
            className: "col-lg-4",
            label: "Api name",
            inputType: "text",
            id: "api_name",
            name: "api_name",
            required: true,
        }, 
        {
            className: "col-lg-4",
            label: "Api URL",
            inputType: "text",
            required: true,
            id: "api_url",
            name: "api_url",
        },
        {
            className: "col-lg-4",
            label: "Api method",
            inputType: "text",
            required: true,
            id: "api_method",
            name: "api_method",
        },
        {
            className: "col-lg-4",
            label: "Api key",
            inputType: "text",
            id: "api_key",
            name: "api_key",
            required: true,
        },
        {
            className: "col-lg-4",
            label: "Api secret",
            inputType: "text",
            id: "api_secret",
            required: true,
            name: "api_secret",
        }, 
        {
            className: "col-lg-4",
            label: "Api master",
            inputType: "number",
            id: "api_master_id",
            required: true,
            name: "api_master_id",
        }, 
        {
            className: "col-lg-4",
            label: "Timeout",
            inputType: "number", 
            required: true,
            id: "timeout",
            name: "timeout",
        },
        {
            className: "col-lg-4",
            label: "Retry count",
            inputType: "number", 
            required: true,
            id: "retry_count",
            name: "retry_count",
        },
        {
            className: "col-lg-4",
            label: "Status",
            inputType: "dropdown",
            options: Settings.enumStatus,
            required: true,
            id: "status",
            name: "status",
        },
        {
            className: "col-lg-4",
            label: "Priority",
            inputType: "number",
            required: true,
            id: "priority",
            name: "priority",
        },
        {
            className: "col-lg-4",
            label: "Type",
            inputType: "number",
            required: true,
            id: "type",
            name: "type",
        },
    ];

    const onClosePopupClick = () => {
        $("html").removeClass("rs_popup_open");
        setClosePopupViewModal(false);
    };

    const executePOSTPopupDocumentAPI = async () => {
        try { 
            let api = Api;
            api.setUserToken();

            const res = await api
                .axios()
                .post(
                    Settings.apiAppUrl + "/api-details/",
                    popupFormData,
                    { cancelToken: cancelTokenSource.token }
                );

                if (res?.data?.success) {
                    Helper.alert(res?.data?.message || 'Api master created successfully', 'success');
                    reloadParentGrid();
                    onClosePopupClick(); 
                } else {
                    Helper.alert(res?.data?.message, 'error')
                }
        } catch (error) {
            getPopupMessageBasedOnStatus(error);
        }
    };

    const handleSubmit = () => {
        if (!popupFormValidator.isValid({ ...popupFormData })) {
            popupFormValidator.displayMessage();
            popupFormValidator.reset();
            return;
        }

        if (!popupFormData.status && popupFormData.status !== 0) {
            Helper.alert('Status field is required', 'error');
            return;
        };

        Helper.createDebouncedAPIFunction(
            [executePOSTPopupDocumentAPI],
            setApiCallBtn,
            cancelTokenSource
        )();
    };
    return (
        <Popup
            autoOpen={true}
            width="900px"
            onClose={onClosePopupClick}
        >
            {(
                <>
                    <h5 className="create_rfq_modal__title">Create Api Master</h5>

                    <Collapse
                        className="mt-4 mb-4"
                        open={true}
                        title={"General Information"}
                    >
                        <Form>
                            <div className="container-fluid">
                                <FieldsRenderer
                                    updateState={setPopupFormData}
                                    currentState={popupFormData}
                                    fieldsArray={fieldsArrayGeneral}
                                />
                            </div>
                        </Form>
                    </Collapse>
                </>
            )}

            <div
                className="addDocumentNumber-body-buttons"
                style={{ justifyContent: "flex-end" }}
            >
                <Button
                    isActive={false}
                    title={"Cancel"}
                    onClick={onClosePopupClick}
                />
                <Button
                    isDisable={apiCallBtn}
                    className="solid_btn"
                    isActive={true}
                    title={<div><span> {"Create"} </span> {apiCallBtn ? <output className="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output> : ''}</div>}
                    onClick={handleSubmit}
                />
            </div>
        </Popup>
    );
};
 
const mapStateToProps = (state) => {
    return {
      auth:state.auth
    }
  }
   
  export default connect(mapStateToProps) (ApiMasterFormsPopup);